/**
 * 渔场API
 * 
 * @Author: szs
 * @Date: 2022-05-28
 * @Last Modified time: 2022-05-28
 */

import http from '@/utils/request';
const apis = {

  // 获取投料机列表
  getFishFeederList(dto) {
    return http.get({
      url: '/pc/fishFeeder/getFishFeederList',
      data: dto
    });
  },

  // 获取投料机
  getFishFeeder(dto) {
    return http.get({
      url: '/pc/fishFeeder/getFishFeeder',
      data: dto
    });
  },

  // 保存投料机
  saveFishFeeder(dto) {
    return http.post({
      url: '/pc/fishFeeder/saveFishFeeder',
      data: dto,
      typea: 1
    });
  },

  // 删除投料机
  delFishFeeder(id) {
    return http.post({
      url: '/pc/fishFeeder/delFishFeeder',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },



  // 获取生长参数列表
  getFishGrowList(dto) {
    return http.get({
      url: '/pc/fishGrow/getFishGrowList',
      data: dto
    });
  },

  // 获取生长参数
  getFishGrow(dto) {
    return http.get({
      url: '/pc/fishGrow/getFishGrow',
      data: dto
    });
  },

  // 保存生长参数
  saveFishGrow(dto) {
    return http.post({
      url: '/pc/fishGrow/saveFishGrow',
      data: dto,
      typea: 1
    });
  },

  // 删除生长参数
  delFishGrow(id) {
    return http.post({
      url: '/pc/fishGrow/delFishGrow',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },



}
export default apis